import { render } from "./AcaoSocial.vue?vue&type=template&id=265b27dc&scoped=true&lang=pug"
import script from "./AcaoSocial.vue?vue&type=script&lang=js"
export * from "./AcaoSocial.vue?vue&type=script&lang=js"

import "./AcaoSocial.vue?vue&type=style&index=0&id=265b27dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265b27dc"]])

export default __exports__